import Item from '../Item';
import FSelect from '@/plugins/form/FSelect';
import FPhone from '@/plugins/form/FPhone';
import FInput from '@/plugins/form/FInput';

import component from './component.vue';

export default class extends Item {
  component = component;

  tourist = new FSelect({
    label: 'Турист',
    required: true,
    options: [
      {
        value: 0,
        label: 'Не турист',
      },
    ],
  });

  phone = new FPhone({
    label: 'Телефон',
    required: true,
  });

  email = new FInput({
    label: 'Email',
    required: true,
  });

  constructor(props) {
    super(props);
    this.setItems([
      ['tourist', this.tourist],
      ['phone', this.phone],
      ['email', this.email],
    ]);
    this.tourist.$subscribe(() => {
      const val = this.tourist.value?.value;
      this.age.show = !val;
      this.gender.show = !val;
      this.birthday.show = !val;
    });
    this.citizenship.show = true;
    this.documentType.show = true;
    this.documentNumber.show = true;
    this.documentFrom.show = true;
    this.documentType.disabled = true;
    this.tourist.value = {
      value: 0,
      label: 'Не турист',
    };
  }

  get data() {
    const data = super.data;
    data.IsMain = true;
    data.IsTourist = false;
    data.Email = this.email.value;
    data.ContactTelephoneNumber = this.phone.value;
    return data;
  }

  $validate() {
    if (!this.tourist.value?.value) {
      return super.$validate();
    }
    return Promise
      .all([
        this.phone.$validate(),
        this.email.$validate(),
      ])
      .then(() => {
        this.error = '';
        return Promise.resolve();
      });
  }

  setTouristOptions(items) {
    this.tourist.options = [
      {
        value: 0,
        label: 'Не турист',
      },
      ...items.filter(i => i.age.value?.value === 0)
        .map((i, j) => ({
          value: j + 1,
          label: i.fio.value || `Турист ${j + 1}`,
        })),
    ];
  }
}
